module.exports = __webpack_public_path__ + "static/media/success.5821a541.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/success.svg
// module id = 243
// module chunks = 7